document.querySelectorAll('.anchor-link').forEach((link) => {
  link.addEventListener('click', (e) => {
    onAnchorLinkClick(e);
  });
});

document.getElementById('jump_to').addEventListener('change', (e) => {
  const anchorLinks = document.querySelector('.faqs_anchor-links');
  const targetAnchorLink = anchorLinks.querySelector(
    `[href="${e.currentTarget.value}"]`
  );
  if (!targetAnchorLink) return;
  targetAnchorLink.click();
});

function onAnchorLinkClick(e) {
  const currentLink = e.currentTarget;
  if (currentLink.closest('div').querySelector('.anchor-link--active'))
    currentLink
      .closest('div')
      .querySelector('.anchor-link--active')
      .classList.remove('anchor-link--active');

  currentLink.classList.add('anchor-link--active');
}
